import { TableBody, TableCell, TableRow } from '@/components/ui';
import { Skeleton } from '@/components/custom';

type TProps = {
	rows?: number;
};

const DataTableBodySkeleton = ({ rows = 8 }: TProps) => (
	<TableBody>
		{Array.from({ length: rows }).map((_, i) => (
			<TableRow key={i} className="h-12">
				<TableCell className="w-[150px] py-1"><Skeleton className="h-4 w-28" /></TableCell>
				<TableCell className="py-1"><Skeleton className="h-4 w-32" /></TableCell>
				<TableCell className="w-[100px] py-1"><Skeleton className="h-4 w-14" /></TableCell>
				<TableCell className="w-[180px] py-1"><Skeleton className="h-5 w-16 rounded-full" /></TableCell>
				<TableCell className="w-[150px] py-1"><Skeleton className="h-4 w-28" /></TableCell>
			</TableRow>
		))}
	</TableBody>
);

export default DataTableBodySkeleton;
